import React from 'react';
import type {AtomRenderProps} from '@packages/systems/wfdl';
import {buttonStyle} from './styles';
import {withSystem, withMeta, Plugins, Atom} from '@packages/systems/wfdl';
import {typeName, qualify, iconName} from '@packages/systems/wfdl-Qualified';
import {
  HIDE_CART_COUNT_DEFAULT,
  HIDE_CART_COUNT_KEY,
  NODE_TYPE_COMMERCE_CART_OPEN_LINK,
} from '@packages/systems/commerce/constants';
import {SHARED_ANCHOR_NODE_CONSTRAINTS_DESCENDANTS} from '@packages/systems/core/constants/SharedConstraintRules';
import {
  TText,
  TListOfElement,
  TRecord,
  TTypeConstructor,
} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {
  EvaluatedNodeData,
  getBooleanOrElse,
  getChildren,
  getInPojo,
} from '@packages/utilities/data-utils';

const CommerceCartOpenLink = Atom.createRender((props: AtomRenderProps) => {
  const {attributes, classes, context, data, generateAttributes, renderChild} =
    props;

  const newContext = context.set(
    HIDE_CART_COUNT_KEY,
    getBooleanOrElse(
      getInPojo(data, ['commerce', HIDE_CART_COUNT_KEY]),
      HIDE_CART_COUNT_DEFAULT
    )
  );

  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a
      {...generateAttributes(attributes, classes)}
      role="button"
      aria-haspopup="dialog"
      aria-label="Open cart"
      data-node-type={NODE_TYPE_COMMERCE_CART_OPEN_LINK}
      href="#"
    >
      {getChildren(data).map((child: EvaluatedNodeData) =>
        renderChild(child, newContext)
      )}
    </a>
  );
});

const config = createIntegratedAtom({
  displayName: 'Cart Button',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Button')),
  },
  showEmpty: false,
  constraints: {
    pinToParent: true,
    descendants: [
      {
        is: 'CommerceCartOpenLinkCount',
        rule: 'ExactlyOne',
        messages: {
          remove: 'Item Count can be hidden in Cart Button settings.',
        },
      },
      ...SHARED_ANCHOR_NODE_CONSTRAINTS_DESCENDANTS,
    ],
  },
  style: {
    base: {
      main: {
        noPseudo: buttonStyle,
      },
    },
  },
  render: CommerceCartOpenLink,
  fields: {
    block: withSystem({private: true}, TText),
    children: TListOfElement,
    commerce: TRecord({
      type: withSystem(
        {
          defaultValue: 'cart-open-link',
          private: true,
        },
        TText
      ),
      hideCartCount: withMeta(
        {
          isOpposite: true,
        },
        withSystem(
          {
            label: 'Cart Quantity',
            labelVariant: 'hidden',
            defaultValue: false,
            isFullWidth: true,
          },
          TTypeConstructor(
            qualify(Plugins.name('Basic'), typeName('SwitchLabelType'))
          )
        )
      ),
    }),
  },
});

export default config;
